import PropTypes from "prop-types";
import React from "react";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import IconButton from "material-ui/IconButton";
import DeleteIcon from "material-ui-icons/Delete";
import SyncIcon from "material-ui-icons/Sync";
import classNames from "classnames";

import compose from "./react-big-calendar/addons/dragAndDrop/compose";

import styles from "./Event.scss";

const Event = (handleSyncFailed, handleDeletePlanning) =>
  class BaseEvent extends React.Component {
    static propTypes = {
      connectBottomDragPreview: PropTypes.func.isRequired,
      connectBottomDragSource: PropTypes.func.isRequired,
      connectTopDragPreview: PropTypes.func.isRequired,
      connectTopDragSource: PropTypes.func.isRequired,
      event: PropTypes.objectOf(PropTypes.any).isRequired,
      title: PropTypes.string,
    };

    static defaultProps = {
      title: "",
    };

    componentDidMount() {
      this.props.connectTopDragPreview(getEmptyImage(), {
        captureDraggingState: true,
      });
      this.props.connectBottomDragPreview(getEmptyImage(), {
        captureDraggingState: true,
      });
    }

    render() {
      const { title, event, connectTopDragSource, connectBottomDragSource } =
        this.props;

      const [Top, Bottom] = [connectTopDragSource, connectBottomDragSource].map(
        (connectSource) => {
          const jsx = (
            <div className="rbc-addons-dnd-resize-anchor">
              <div className="rbc-addons-dnd-resize-icon" />
            </div>
          );
          return connectSource(jsx);
        }
      );

      return (
        <div className="rbc-addons-dnd-resizable-event">
          {Top}
          <h3 className="mt2">{title}</h3>
          <div className={classNames({ [styles.buttons]: true, mt2: true })}>
            {event.syncFailed && (
              <IconButton
                className={styles.button}
                aria-label="Synchroniser"
                disabled={event.requesting}
                onClick={(e) => {
                  handleSyncFailed(event);
                  e.stopPropagation();
                }}
              >
                <SyncIcon />
              </IconButton>
            )}
            <IconButton
              className={styles.button}
              aria-label="Supprimer"
              disabled={event.requesting}
              onClick={(e) => {
                e.stopPropagation();
                handleDeletePlanning(event);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </div>
          {Bottom}
        </div>
      );
    }
  };

const eventSourceTop = {
  beginDrag: ({ event }) => ({ ...event, type: "resizeTop" }),
};

const eventSourceBottom = {
  beginDrag: ({ event }) => ({ ...event, type: "resizeBottom" }),
};

const eventSourceLeft = {
  beginDrag: ({ event }) => ({ ...event, type: "resizeLeft" }),
};

const eventSourceRight = {
  beginDrag: ({ event }) => ({ ...event, type: "resizeRight" }),
};

export default ({ handleSyncFailed, handleDeletePlanning }) =>
  compose(
    DragSource("resize", eventSourceTop, (connect) => ({
      connectTopDragPreview: connect.dragPreview(),
      connectTopDragSource: connect.dragSource(),
    })),
    DragSource("resize", eventSourceBottom, (connect) => ({
      connectBottomDragSource: connect.dragSource(),
      connectBottomDragPreview: connect.dragPreview(),
    })),
    DragSource("resize", eventSourceLeft, (connect) => ({
      connectLeftDragSource: connect.dragSource(),
      connectLeftDragPreview: connect.dragPreview(),
    })),
    DragSource("resize", eventSourceRight, (connect) => ({
      connectRightDragSource: connect.dragSource(),
      connectRightDragPreview: connect.dragPreview(),
    }))
  )(Event(handleSyncFailed, handleDeletePlanning));



// WEBPACK FOOTER //
// ./src/pages/plannings/Event.jsx